const RemoveMessage = () => ({ type: 'DELETE' });
const SetMessage = (data) => ({ type: 'SET', data });
export { RemoveMessage, SetMessage };
